document.querySelectorAll('.video-wrapper').forEach(wrapper => {
  const video = wrapper.querySelector('video');
  const playBtn = wrapper.querySelector('.play-btn');
  const bestTimeExpert = document.querySelector('.best-time-expert')

  if (!video || !playBtn) return; // якщо щось відсутнє — пропускаємо

  // Натискання на кнопку ▶️
  playBtn.addEventListener('click', () => {
    video.play();
    playBtn.style.display = 'none';
    if (bestTimeExpert) {
      bestTimeExpert.style.display = 'none';
    }
  });

  // Натискання на саме відео — пауза / відтворення
  video.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      playBtn.style.display = 'none';
      if (bestTimeExpert) {
      bestTimeExpert.style.display = 'none';
    }
    } else {
      video.pause();
      playBtn.style.display = 'block';
      if (bestTimeExpert) {
      bestTimeExpert.style.display = 'block';
    }
    }
  });

  // Додатково — коли відео закінчиться, показати кнопку знову
  video.addEventListener('ended', () => {
    playBtn.style.display = 'block';
    if (bestTimeExpert) {
      bestTimeExpert.style.display = 'block';
    }
  });
});

// Smooth marquee tickers (header-slider, banner-logos, try-risk-free-spinner)
// document.addEventListener('DOMContentLoaded', function () {
//   if (typeof gsap === 'undefined') return;

//   function setupTicker(containerSelector, trackSelector, pxPerSecond) {
//     var container = document.querySelector(containerSelector);
//     if (!container) return;
//     var track = container.querySelector(trackSelector);
//     if (!track) return;
//     if (track.__tickerInitialized) return;
//     track.__tickerInitialized = true;

//     try {
//       track.style.animation = 'none';
//       track.style.webkitAnimation = 'none';
//     } catch (e) {}

//     var originals = Array.from(track.children);
//     if (!originals.length) return;
//     originals.forEach(function (el) { if (!el.style.display) el.style.display = 'inline-block'; });

//     function trackWidth() { return track.scrollWidth; }
//     function containerWidth() { return container.clientWidth; }

//     var minWidth = Math.max(containerWidth() * 2, trackWidth());
//     while (trackWidth() < minWidth) {
//       originals.forEach(function (node) { track.appendChild(node.cloneNode(true)); });
//     }

//     var distance = Math.max(containerWidth(), trackWidth() / 2);
//     var duration = distance / Math.max(20, pxPerSecond || 60);

//     gsap.set(track, { x: 0, willChange: 'transform' });
//     gsap.to(track, {
//       x: '-=' + distance,
//       duration: duration,
//       ease: 'none',
//       repeat: -1,
//       onRepeat: function () { gsap.set(track, { x: 0 }); }
//     });

//     var resizeTimeout;
//     window.addEventListener('resize', function () {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(function () {
//         try { gsap.killTweensOf(track); } catch (e) {}
//         gsap.set(track, { x: 0 });
//         var needed = Math.max(containerWidth() * 2, trackWidth());
//         while (trackWidth() < needed) {
//           Array.from(originals).forEach(function (node) { track.appendChild(node.cloneNode(true)); });
//         }
//         var newDistance = Math.max(containerWidth(), trackWidth() / 2);
//         var newDuration = newDistance / Math.max(20, pxPerSecond || 60);
//         gsap.to(track, {
//           x: '-=' + newDistance,
//           duration: newDuration,
//           ease: 'none',
//           repeat: -1,
//           onRepeat: function () { gsap.set(track, { x: 0 }); }
//         });
//       }, 150);
//     });
//   }

//   setupTicker('.header-slider', '.slider-track', 70);
//   setupTicker('.banner-logos', '.banner-logos-slider-track', 60);
//   setupTicker('.try-risk-free-spinner', '.spinner-track', 80);
// });


// Scientific references: toggle with height/opacity transitions on pre-collapsed blocks
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.scientific-references-button');
  const panels = document.querySelectorAll('.scientific-references-description-open');
  if (!button || !panels.length) return;

  function isOpen(el) {
    const h = getComputedStyle(el).height;
    return h !== '0px' && h !== '0';
  }
  function openPanel(el) {
    el.style.height = el.scrollHeight + 'px';
    el.style.opacity = '1';
    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      el.style.height = 'auto';
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('transitionend', onEnd);
  }
  function closePanel(el) {
    if (el.style.height === 'auto') {
      el.style.height = el.scrollHeight + 'px';
      void el.offsetHeight; // reflow
    }
    el.style.height = '0px';
    el.style.opacity = '0';
  }

  button.addEventListener('click', function (e) {
    e.preventDefault();
    panels.forEach(function (el) {
      if (isOpen(el)) {
        closePanel(el);
      } else {
        openPanel(el);
      }
    });
  });
});

// // Smooth marquee tickers (header-slider, banner-logos, try-risk-free-spinner)
// (function () {
//   // Initializes all tickers within a root element (defaults to document)
//   function initShopifyTicker(root) {
//     var scope = root || document;
//     var tickers = scope.querySelectorAll('[data-shopify-type="ticker"]');
//     if (!tickers.length) return;

//     Array.from(tickers).reverse().forEach(function (ticker) {
//       var initialContainer = ticker.querySelector('.shopify-ticker-initial-child-container');
//       var primaryTrack = initialContainer && initialContainer.closest('.shopify-ticker');
//       var secondaryTrack = primaryTrack && primaryTrack.nextElementSibling;
//       var tracks = [primaryTrack, secondaryTrack];
//       var reversed = ticker.getAttribute('data-shopify-ticker-is-reversed') === 'true';
//       var speed = +(ticker.getAttribute('data-shopify-ticker-speed') || 50);
//       var pause = ticker.getAttribute('data-shopify-ticker-pause') === 'true' || false;

//       if (!(ticker && initialContainer)) return;

//       var children = initialContainer.children;
//       var multiplier = 1;
//       var duration = 0;

//       var refresh = function () {
//         var tickerRect = ticker.getBoundingClientRect();
//         var initialRect = initialContainer.getBoundingClientRect();
//         if (tickerRect && initialRect) {
//           var visibleWidth = Math.min(tickerRect.width, 9999);
//           var initialWidth = initialRect.width;
//           var cs = window.getComputedStyle(initialContainer);
//           var colGap = cs.columnGap ? (typeof cs.columnGap === 'number' ? (cs.columnGap + 'px') : cs.columnGap) : '0px';
//           ticker.style.setProperty('--gap', colGap);

//           multiplier = (initialWidth && visibleWidth && initialWidth < visibleWidth) ? Math.ceil(visibleWidth / initialWidth) : 1;
//           duration = initialWidth * multiplier / speed;
//         }

//         if (ticker.style.getPropertyValue('--multiplier') !== String(multiplier)) {
//           if (primaryTrack) primaryTrack.replaceChildren(initialContainer);
//           if (secondaryTrack) secondaryTrack.innerHTML = '';

//           Array.from(tracks).forEach(function (track, trackIndex) {
//             if (!track) return;
//             var repeats = Math.max(0, trackIndex === 0 ? multiplier - 1 : multiplier);
//             for (var r = 0; r < repeats; r++) {
//               Array.from(children).forEach(function (child) {
//                 var clone = child.cloneNode(true);
//                 track.appendChild(clone);
//               });
//             }
//           });
//         }

//         ticker.style.setProperty('--play', 'running');
//         ticker.style.setProperty('--direction', reversed ? 'reverse' : 'normal');
//         ticker.style.setProperty('--duration', duration + 's');
//         ticker.style.setProperty('--pause-on-hover', pause ? 'paused' : 'running');
//         ticker.style.setProperty('--multiplier', String(multiplier));

//         // Safari lazy loading quirk: force eager for visibility
//         if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
//           ticker.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
//             img.loading = 'eager';
//           });
//         }
//       };
// // var refresh = function () {
// //   var tickerRect = ticker.getBoundingClientRect();
// //   var initialRect = initialContainer.getBoundingClientRect();
// //   if (tickerRect && initialRect) {
// //     var visibleWidth = tickerRect.width;
// //     var initialWidth = initialRect.width;
// //     var cs = window.getComputedStyle(initialContainer);
// //     var colGap = parseFloat(cs.columnGap) || 0;
// //     ticker.style.setProperty('--gap', cs.columnGap || '0px');

// //     // Обчислюємо, скільки разів повторити контент
// //     multiplier = Math.ceil((visibleWidth + colGap) / (initialWidth + colGap)) + 1;
// //     duration = initialWidth * multiplier / speed;
// //   }

// //   if (ticker.style.getPropertyValue('--multiplier') !== String(multiplier)) {
// //     if (primaryTrack) primaryTrack.replaceChildren(initialContainer);
// //     if (secondaryTrack) secondaryTrack.innerHTML = '';

// //     Array.from(tracks).forEach(function (track, trackIndex) {
// //       if (!track) return;
// //       // Перший трек: multiplier - 1 повтор, другий трек: multiplier повторів
// //       var repeats = trackIndex === 0 ? multiplier - 1 : multiplier;
// //       for (var r = 0; r < repeats; r++) {
// //         Array.from(children).forEach(function (child) {
// //           var clone = child.cloneNode(true);
// //           track.appendChild(clone);
// //         });
// //       }
// //     });
// //   }

// //   ticker.style.setProperty('--play', 'running');
// //   ticker.style.setProperty('--direction', reversed ? 'reverse' : 'normal');
// //   ticker.style.setProperty('--duration', duration + 's');
// //   ticker.style.setProperty('--pause-on-hover', pause ? 'paused' : 'running');
// //   ticker.style.setProperty('--multiplier', String(multiplier));

// //   // Safari: force eager loading для картинок
// //   if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
// //     ticker.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
// //       img.loading = 'eager';
// //     });
// //   }
// // };
//       refresh();
//       try {
//         var ro = new ResizeObserver(refresh);
//         ro.observe(ticker);
//         ro.observe(initialContainer);
//       } catch (e) {
//         // ResizeObserver not available; best-effort initial sizing
//       }
//     });
//   }

//   // Public entrypoint
//   window.__shopifyInitTicker = function (root) {
//     initShopifyTicker(root || document);
//   };

//   // Auto-initialize on DOM ready
//   function ready() {
//     window.__shopifyInitTicker && window.__shopifyInitTicker();
//   }
//   if (document.readyState !== 'loading') {
//     ready();
//   } else {
//     document.addEventListener('DOMContentLoaded', ready);
//   }

//   // Re-initialize when sections are (re)loaded in Shopify theme editor
//   document.addEventListener('shopify:section:load', function (e) {
//     var root = e && e.target ? e.target : document;
//     window.__shopifyInitTicker && window.__shopifyInitTicker(root);
//   });
// })();


// Smooth marquee tickers (header-slider, banner-logos, try-risk-free-spinner)
(function () {
    // Initializes all tickers within a root element (defaults to document)
    function initShopifyTicker(root) {
      var scope = root || document;
      var tickers = scope.querySelectorAll('[data-shopify-type="ticker"]');
      if (!tickers.length) return;
  
      Array.from(tickers).reverse().forEach(function (ticker) {
        var initialContainer = ticker.querySelector('.shopify-ticker-initial-child-container');
        var primaryTrack = initialContainer && initialContainer.closest('.shopify-ticker');
        var secondaryTrack = primaryTrack && primaryTrack.nextElementSibling;
        var tracks = [primaryTrack, secondaryTrack];
        var reversed = ticker.getAttribute('data-shopify-ticker-is-reversed') === 'true';
        var speed = +(ticker.getAttribute('data-shopify-ticker-speed') || 50);
        var pause = ticker.getAttribute('data-shopify-ticker-pause') === 'true' || false;
  
        if (!(ticker && initialContainer)) return;
  
        var children = initialContainer.children;
        var multiplier = 1;
        var duration = 0;
  
        var refresh = function () {
          var tickerRect = ticker.getBoundingClientRect();
          var initialRect = initialContainer.getBoundingClientRect();
          if (tickerRect && initialRect) {
            var visibleWidth = Math.min(tickerRect.width, 9999);
            var initialWidth = initialRect.width;
            var cs = window.getComputedStyle(initialContainer);
            var rawGap = cs.getPropertyValue('column-gap') || cs.columnGap || '0px';
            var parsedGap = parseFloat(rawGap);
            var colGap = isNaN(parsedGap) ? '0px' : (parsedGap + 'px');
            ticker.style.setProperty('--gap', colGap);
  
            multiplier = (initialWidth && visibleWidth && initialWidth < visibleWidth) ? Math.ceil(visibleWidth / initialWidth) : 1;
            duration = initialWidth * multiplier / speed;
          }
  
          if (ticker.style.getPropertyValue('--multiplier') !== String(multiplier)) {
            if (primaryTrack) primaryTrack.replaceChildren(initialContainer);
            if (secondaryTrack) secondaryTrack.innerHTML = '';
  
            Array.from(tracks).forEach(function (track, trackIndex) {
              if (!track) return;
              var repeats = Math.max(0, trackIndex === 0 ? multiplier - 1 : multiplier);
              for (var r = 0; r < repeats; r++) {
                var containerClone = initialContainer.cloneNode(true);
                containerClone.classList.remove('shopify-ticker-initial-child-container');
                track.appendChild(containerClone);
              }
            });
          }
  
          ticker.style.setProperty('--play', 'running');
          ticker.style.setProperty('--direction', reversed ? 'reverse' : 'normal');
          ticker.style.setProperty('--duration', duration + 's');
          ticker.style.setProperty('--pause-on-hover', pause ? 'paused' : 'running');
          ticker.style.setProperty('--multiplier', String(multiplier));
  
          // Safari lazy loading quirk: force eager for visibility
          if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            ticker.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
              img.loading = 'eager';
            });
          }
        };

        refresh();
        try {
          var ro = new ResizeObserver(refresh);
          ro.observe(ticker);
          ro.observe(initialContainer);
        } catch (e) {
          // ResizeObserver not available; best-effort initial sizing
        }
      });
    }
  
    // Public entrypoint
    window.__shopifyInitTicker = function (root) {
      initShopifyTicker(root || document);
    };
  
    // Auto-initialize on DOM ready
    function ready() {
      window.__shopifyInitTicker && window.__shopifyInitTicker();
    }
    if (document.readyState !== 'loading') {
      ready();
    } else {
      document.addEventListener('DOMContentLoaded', ready);
    }
  
    // Re-initialize when sections are (re)loaded in Shopify theme editor
    document.addEventListener('shopify:section:load', function (e) {
      var root = e && e.target ? e.target : document;
      window.__shopifyInitTicker && window.__shopifyInitTicker(root);
    });
  })();